import './lib/reportErrors';
import { createApp, nextTick } from 'vue';
import { createPinia } from 'pinia';
// @ts-ignore
import App from './App.vue';
import gsap from 'gsap';
import './lib/ripple';
import './lib/gsapBlurPlugin';
import './lib/hmr';
import './lib/preventSubmit';
// @ts-ignore
import $ from 'jquery';
import useContent from './stores/useContent';
import useEditMode from './stores/useEditMode';
import getContent, { mergeCustomContent } from './lib/getContent';
import registerComponents from './lib/registerComponents';
import { loadCourseCss } from './lib/getContent';
import getRouter from './lib/router';
import { createAppRouter } from './lib/router';
import getQueryParameter from './lib/getQueryParameter';
import loadTranslations from './lib/loadTranslations';
import useTranslations from './stores/useTranslations';
// import { getSuspendEdits } from './lib/callModContent';
import SCORM from './lib/SCORM';
import { preloadTipTap } from './lib/MaybeTiptap';
import bugAlert from './lib/bugAlert';
import apm from './lib/apm';

// @ts-ignore
window.gsap = gsap;
// @ts-ignore
window.$ = $;

gsap.config({ nullTargetWarn: false });

// create and load the Pinia store before creating the Vue app
const pinia = createPinia();
const store = useContent(pinia);
const editModeStore = useEditMode(pinia);

// @ts-ignore
window.store = store;
// @ts-ignore
window.editModeStore = editModeStore;

const isWord = Boolean(getQueryParameter('word'));

console.log({
  MODE: import.meta.env.MODE,
  BASE_URL: import.meta.env.BASE_URL,
  PROD: import.meta.env.PROD,
  DEV: import.meta.env.DEV
});

if (import.meta.env.DEV) {
  const updateYAML = async (
    rawOrObject: string | { baseYaml?: string; customYaml?: string }
  ) => {
    try {
      const loadYaml = (await import('js-yaml')).load;
      let baseContent = store.content;
      let customContent: Content | undefined = undefined;

      // Handle both legacy string format and new object format
      if (typeof rawOrObject === 'string') {
        // Legacy: treat as custom YAML
        baseContent = store.content;
        customContent = loadYaml(rawOrObject) as Content;
      } else if (rawOrObject && typeof rawOrObject === 'object') {
        // New format: { baseYaml?, customYaml? }
        if (rawOrObject.baseYaml) {
          baseContent = loadYaml(rawOrObject.baseYaml) as Content;
        } else {
          baseContent = store.content;
        }

        if (rawOrObject.customYaml) {
          customContent = loadYaml(rawOrObject.customYaml) as Content;
        } else {
          customContent = undefined;
        }
      } else {
        throw new Error('Invalid updateYAML argument');
      }

      const merged = mergeCustomContent(baseContent, customContent);

      // remove en-GB from languages (added by the language widget)
      if (merged.languages)
        merged.languages = merged.languages?.filter(l => l !== 'en-GB');

      useContent().load({ content: merged });
    } catch (e) {
      bugAlert(e);
    }
  };

  // @ts-ignore
  window.updateYAML = updateYAML;

  // @ts-ignore
  window.injectCss = async (css = '') => {
    const el = document.getElementById('custom-css') as HTMLStyleElement;
    if (!el) return;
    el.innerHTML = css;
  };
}

void preloadTipTap().catch(console.error);

const [content] = await Promise.all([getContent(), loadCourseCss({ isWord })]);

store.load({ content });

await nextTick();

window.dispatchEvent(new CustomEvent('uc:readytoinject'));

const { compiled } = store;

const defaultLanguage = compiled?.['default-language'];

const languages = compiled.languages?.length
  ? compiled.languages
  : defaultLanguage
    ? [defaultLanguage]
    : [];

if (languages.length) {
  const baseCourseId = compiled['base-course'] ?? undefined;
  const translations = await loadTranslations(languages, baseCourseId);
  useTranslations().load(translations);
}

if (defaultLanguage && !SCORM.get('locale')) {
  SCORM.set('locale', defaultLanguage);
}

apm.addLabels({
  firm: SCORM.getFirm(),
  courseId: SCORM.getCourseId(),
  locale: SCORM.get('locale') as string,
  mode: import.meta.env.MODE,
  connected: SCORM.isConnected(),
  app: 'runtime'
});

const app = createApp(App);
app.use(pinia);
app.config.performance = true;
app.config.errorHandler = err =>
  bugAlert(err instanceof Error ? err : new Error(String(err)));
app.use(createAppRouter(compiled));
registerComponents(app);
app.mount('#app');

gsap.to('.app-loading', {
  duration: 0.1,
  opacity: 0,
  onComplete: () => {
    document.querySelector('.app-loading')?.remove();
  }
});

if (isWord) {
  await nextTick();
  document
    .querySelectorAll('style, [rel="stylesheet"]')
    .forEach(s => s.remove());
  import('./word.css');
}

// @ts-ignore
window.router = getRouter();
// @ts-ignore
window.translations = useTranslations();
